import React from 'react';
import Cookies from 'js-cookie';
import {
	Card, Row, Col, Form, DatePicker, Select, Button,
	Tag, Spin, message,
} from 'antd';
import {
	SearchOutlined, PrinterOutlined, FileTextOutlined,
	ReloadOutlined, TableOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import {
	initHandler, ajaxViewHandler, ajaxHandler, setConfig,
} from '../../store/actions';
import Config from '../../Config';
import { Helmet } from 'react-helmet';
import moment from 'moment';
import '../../assets/laporan.css';

const configClass = {
	title: 'LAPORAN BERITA ACARA BATAL SKPD',
	apiUrl: {
		data      : 'laporan/api/notice/ba-batal-skpd/',
		upt       : 'pegawai/api/upt/',
		kabupaten : 'master/api/kabupaten/',
	},
};

const config = new Config();

class LapBaBatalSkpd extends React.Component {
	formRef = React.createRef();

	constructor(props) {
		super(props);
		this.config = new Config();
		this.state = {
			loading        : false,
			data           : null,
			loadingUpt     : false,
			listUpt        : [],
			loadingKabupaten: false,
			listKabupaten  : [],
			kabupaten_id   : '',
			isMobile       : window.innerWidth <= 768,
		};
	}

	UNSAFE_componentWillMount() {
		this.props.initHandler();
	}

	componentDidMount() {
		this.getMasterList({
			destination: {
				stateProgressName: 'loadingKabupaten',
				endPoint         : configClass.apiUrl.kabupaten,
				stateDestination : 'listKabupaten',
			},
		});
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
		this.initKabupatenFromCookie();
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
	}

	initKabupatenFromCookie() {
		try {
			const rawCookie = Cookies.get(this.config.get_cookie_name() + '_upt');
			if (!rawCookie) return;
			const parsed = JSON.parse(decodeURIComponent(rawCookie));
			const kabupatenId = parsed.kabupaten;
			if (!kabupatenId) return;
			this.setState({ kabupaten_id: kabupatenId });
			setTimeout(() => {
				if (this.formRef.current) {
					this.formRef.current.setFieldsValue({ kabupaten: kabupatenId });
				}
			}, 0);
			this.getMasterList({
				destination: {
					stateProgressName: 'loadingUpt',
					endPoint         : configClass.apiUrl.upt + '?kabupaten=' + kabupatenId,
					stateDestination : 'listUpt',
				},
			});
		} catch (err) {
			console.warn('Cookie _upt tidak valid:', err);
		}
	}

	isKabupatenLocked() {
		try {
			const rawCookie = Cookies.get(this.config.get_cookie_name() + '_upt');
			if (!rawCookie) return false;
			const parsed = JSON.parse(decodeURIComponent(rawCookie));
			return Boolean(parsed.kabupaten && parsed.id);
		} catch (err) {
			return false;
		}
	}

	async getMasterList(rule) {
		const dest = rule.destination;
		this.setState({ [dest.stateProgressName]: true });
		this.props.ajaxViewHandler('get', dest.endPoint)
			.then(() => {
				const res = this.props.responseMsg;
				if (this.props.isSuccess) {
					const list = res.count !== undefined ? res.results
						: res.results !== undefined ? res.results
						: Array.isArray(res) ? res : [res];
					this.setState({ [dest.stateDestination]: list });
				}
				this.setState({ [dest.stateProgressName]: false });
			})
			.catch(() => this.setState({ [dest.stateProgressName]: false }));
	}

	generateSelect(stateName, url, key, value, keyDisplay = '') {
		return this.state['loading' + stateName] ? (
			<img src={process.env.PUBLIC_URL + '/loading_crop.gif'} height="40" />
		) : (
			<Select
				showSearch
				placeholder={'Cari / Pilih ' + stateName}
				disabled={stateName === 'Kabupaten' && this.isKabupatenLocked()}
				optionFilterProp="children"
				allowClear
				style={{ width: '100%' }}
				onSearch={(val) => {
					let urls = url + '?search=' + val;
					if (stateName === 'Upt') urls = `${url}?kabupaten=${this.state.kabupaten_id}&search=${val}`;
					this.getMasterList({
						destination: {
							stateProgressName: 'loading' + stateName + '_searching',
							endPoint         : urls,
							stateDestination : 'list' + stateName,
						},
					});
				}}
				onChange={(val) => {
					if (stateName === 'Kabupaten') {
						this.setState({ kabupaten_id: val }, () => {
							this.getMasterList({
								destination: {
									stateProgressName: 'loadingUpt',
									endPoint         : configClass.apiUrl.upt + '?kabupaten=' + val,
									stateDestination : 'listUpt',
								},
							});
						});
					}
				}}
			>
				{this.state['loading' + stateName + '_searching'] && (
					<Select.Option value=""><Spin size="small" /></Select.Option>
				)}
				{(this.state['list' + stateName]).map((item) => (
					<Select.Option value={item[key]} key={item[key]}>
						{keyDisplay === '' ? item[key] + ' - ' + item[value] : item[keyDisplay] + ' - ' + item[value]}
					</Select.Option>
				))}
			</Select>
		);
	}

	handleSubmit = (values) => {
		let filter = '';
		for (const key in values) {
			if (key.endsWith('_picker')) continue;
			if (values[key] !== undefined && values[key] !== '') {
				filter += (filter === '' ? '?' : '&') + key + '=' + values[key];
			}
		}
		this.setState({ data: null });
		this.getData(filter);
	}

	async getData(filter) {
		message.loading({ content: 'Memuat laporan...', duration: 0, key: 'toast' });
		this.setState({ loading: true, data: null });
		this.props.ajaxViewHandler('get', configClass.apiUrl.data + filter)
			.then(() => {
				const res = this.props.responseMsg;
				if (this.props.isSuccess) {
					message.destroy();
					this.setState({ loading: false, data: res });
				} else {
					this.setState({ loading: false });
					message.error({ content: 'Gagal memuat laporan', duration: 2, key: 'toast' });
				}
			})
			.catch(() => {
				this.setState({ loading: false });
				message.error({ content: 'Gagal request data', duration: 2, key: 'toast' });
			});
	}

	handlePrint = () => {
		const section = document.querySelector('.ba-batal-print-section');
		if (!section) return;
		const parent  = section.parentNode;
		const nextSib = section.nextSibling;
		section.style.display = 'block';
		document.body.appendChild(section);
		const siblings = Array.from(document.body.children).filter(el => el !== section);
		siblings.forEach(el => { el.style.display = 'none'; });
		window.print();
		siblings.forEach(el => { el.style.display = ''; });
		section.style.display = 'none';
		if (nextSib) parent.insertBefore(section, nextSib);
		else parent.appendChild(section);
	}

	fmtRp(val) {
		return 'Rp' + Number(val || 0).toLocaleString('id');
	}

	renderMobileResult(rows) {
		const groups = this.groupRows(rows);
		if (groups.length === 0) {
			return <div style={{ textAlign: 'center', padding: 32, color: '#aaa' }}>Tidak ada data pada tanggal ini.</div>;
		}
		return groups.map((group, gi) => {
			const first = group[0];
			return (
				<div key={gi} style={{
					border: '1px solid #e8edf5', borderRadius: 12, marginBottom: 12, overflow: 'hidden',
					boxShadow: '0 2px 8px rgba(15,40,71,0.06)',
				}}>
					{/* Header grup — data yang di-rowspan */}
					<div style={{
						background: 'linear-gradient(135deg, #0f284709, #1e4d8a0d)',
						padding: '10px 14px',
						borderBottom: '1px solid #e8edf5',
					}}>
						<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
							<div>
								<div style={{ fontWeight: 700, fontSize: 15, color: '#0f2847' }}>{first.nomor_polisi}</div>
								<div style={{ fontSize: 12, color: '#666', marginTop: 2 }}>{first.nama_pemilik}</div>
							</div>
							<div style={{ textAlign: 'right', flexShrink: 0 }}>
								<div style={{ fontSize: 11, color: '#888' }}>Tgl Batal</div>
								<div style={{ fontSize: 12, fontWeight: 600, color: '#0f2847' }}>{first.tanggal_batal}</div>
							</div>
						</div>
						<div style={{ display: 'flex', gap: 8, marginTop: 6, flexWrap: 'wrap' }}>
							<span style={{
								background: '#e6f0fb', color: '#1e4d8a', border: '1px solid #91b4e8',
								borderRadius: 20, fontSize: 11, fontWeight: 600, padding: '1px 8px',
							}}>
								{first.golongan}
							</span>
							<span style={{ fontSize: 12, color: '#555' }}>Masa Laku: {first.masa_laku_skpd}</span>
						</div>
					</div>

					{/* Baris per kejadian */}
					{group.map((r, i) => (
						<div key={i} style={{
							padding: '8px 14px',
							borderBottom: i < group.length - 1 ? '1px dashed #e8edf5' : 'none',
							background: i % 2 === 1 ? '#fafbff' : '#fff',
						}}>
							<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
								<div>
									<div style={{ fontSize: 11, color: '#888' }}>Penyebab</div>
									<div style={{ fontSize: 13, fontWeight: 500 }}>{r.penyebab || '-'}</div>
								</div>
								<div style={{ textAlign: 'right' }}>
									<div style={{ fontSize: 11, color: '#888' }}>SWDKLLJ</div>
									<div style={{ fontSize: 13, fontWeight: 600, color: '#0f2847' }}>{this.fmtRp(r.jumlah_swdkllj)}</div>
								</div>
							</div>
							<div style={{ marginTop: 4 }}>
								<span style={{ fontSize: 11, color: '#888' }}>Loket: </span>
								<span style={{ fontSize: 12 }}>{r.loket || '-'}</span>
							</div>
						</div>
					))}
				</div>
			);
		});
	}

	groupRows(rows) {
		const groups = [];
		const seen   = {};
		rows.forEach(row => {
			if (!seen[row.nomor_polisi]) {
				seen[row.nomor_polisi] = [];
				groups.push(seen[row.nomor_polisi]);
			}
			seen[row.nomor_polisi].push(row);
		});
		return groups;
	}

	render() {
		const { loading, data, isMobile } = this.state;
		const hasData = data !== null;
		const rows    = data?.data || [];
		const ttd     = data?.ttd  || {};
		const tbl     = data?.terbilang || {};
		const tgl     = data?.tanggal || '';
		const uptNama = (data?.upt_nama || '-').toUpperCase();
		const kabNama = (data?.kabupaten_nama || '-').toUpperCase();

		const paragraf1 = tgl
			? `Pada hari ini tanggal ${tbl.hari} bulan ${tbl.bulan} tahun ${tbl.tahun} (${tgl}), Menerangkan bahwa terdapat Pembatalan SKPD pada hari ini tanggal ${tbl.hari} bulan ${tbl.bulan} tahun ${tbl.tahun} (${tgl})`
			: '';
		const paragraf2 = `Pada proses penerimaan Loket Samsat ${uptNama} atas penerimaan Pajak Kendaraan Bermotor (PKB) dan Sumbangan Wajib Dana Kecelakaan Lalu Lintas Jalan (SWDKLLJ) terdapat SKPD batal. Adapun data SKPD Pajak kendaraan sebagai berikut :`;

		return (
			<div style={{ padding: '0 0 24px' }}>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
				</Helmet>

				{/* ── FILTER CARD ── */}
				<Card
					style={{ borderRadius: 14, border: 'none', boxShadow: '0 4px 20px rgba(15,40,71,0.13)', marginBottom: 16 }}
					bodyStyle={{ padding: 0 }}
				>
					<div style={{
						background  : 'linear-gradient(135deg, #0f2847 0%, #1e4d8a 60%, #0a3d6b 100%)',
						borderRadius: '14px 14px 0 0',
						padding     : '20px 28px',
						display: 'flex', alignItems: 'center', justifyContent: 'space-between',
					}}>
						<div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
							<div style={{
								width: 52, height: 52, borderRadius: 12,
								background: 'rgba(255,255,255,0.15)', backdropFilter: 'blur(10px)',
								display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24,
							}}>
								<FileTextOutlined style={{ color: '#fff' }} />
							</div>
							<div>
								<div style={{ color: '#fff', fontWeight: 700, fontSize: 18, lineHeight: 1.3 }}>
									Berita Acara Batal SKPD
								</div>
								<div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 13, marginTop: 2 }}>
									Rekap pembatalan SKPD yang telah disetujui per tanggal
								</div>
							</div>
						</div>
						{loading ? (
							<Tag color="processing">Memuat...</Tag>
						) : hasData ? (
							<Tag color="success">Data Siap</Tag>
						) : (
							<Tag style={{ background: 'rgba(255,255,255,0.15)', color: '#fff', border: 'none' }}>
								Pilih filter untuk mulai
							</Tag>
						)}
					</div>

					<div style={{ padding: '20px 28px' }}>
						<Form
							layout="vertical" name="fdata" onFinish={this.handleSubmit} ref={this.formRef}
							initialValues={{ tanggal_picker: moment(), tanggal: moment().format('DD-MM-YYYY') }}
						>
							<Row gutter={[16, 0]} align="bottom">
								<Col xs={24} sm={12} md={5}>
									<Form.Item label="Kabupaten" name="kabupaten">
										{this.generateSelect('Kabupaten', configClass.apiUrl.kabupaten, 'id', 'name')}
									</Form.Item>
								</Col>
								<Col xs={24} sm={12} md={5}>
									<Form.Item label="UPT" name="upt" rules={[{ required: true, message: 'UPT wajib dipilih' }]}>
										{this.generateSelect('Upt', configClass.apiUrl.upt, 'id', 'nama', 'id')}
									</Form.Item>
								</Col>
								<Col xs={24} sm={12} md={4}>
									<Form.Item label="Tanggal" name="tanggal_picker" rules={[{ required: true, message: 'Pilih tanggal' }]}>
										<DatePicker
											placeholder="dd-mm-yyyy"
											format="DD-MM-YYYY"
											style={{ width: '100%' }}
											onChange={(_, ds) => this.formRef.current.setFieldsValue({ tanggal: ds })}
										/>
									</Form.Item>
									<Form.Item name="tanggal" style={{ display: 'none' }}>
										<input type="hidden" />
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={[8, 8]}>
								<Col xs={hasData ? 12 : 24} sm="auto">
									<Button
										type="primary"
										htmlType="submit"
										loading={loading}
										icon={<SearchOutlined />}
										block={isMobile}
										style={{
											background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
											border: 'none', borderRadius: 8, fontWeight: 600, height: 38,
										}}
									>
										Proses
									</Button>
								</Col>
								{hasData && (
									<Col xs={12} sm="auto">
										<Button
											icon={<ReloadOutlined />}
											block={isMobile}
											style={{ borderRadius: 8, height: 38 }}
											onClick={() => {
												this.formRef.current.resetFields();
												this.setState({ data: null, kabupaten_id: '', listUpt: [] }, () => {
													this.initKabupatenFromCookie();
												});
											}}
										>
											Reset
										</Button>
									</Col>
								)}
							</Row>
						</Form>
					</div>
				</Card>

				{/* ── LOADING ── */}
				{loading && (
					<Card style={{ borderRadius: 14, border: 'none', textAlign: 'center', padding: 48 }}>
						<Spin size="large" />
						<div style={{ marginTop: 16, color: '#888' }}>Memuat laporan...</div>
					</Card>
				)}

				{/* ── RESULT CARD ── */}
				{hasData && !loading && (
					<Card
						style={{ borderRadius: 14, border: 'none', boxShadow: '0 4px 20px rgba(15,40,71,0.08)' }}
						bodyStyle={{ padding: 0 }}
					>
						<div style={{
							background  : 'linear-gradient(90deg, #f0f4ff 0%, #fff 100%)',
							padding     : isMobile ? '12px 14px' : '14px 24px',
							borderRadius: '14px 14px 0 0',
							borderBottom: '1px solid #e8edf5',
							display: 'flex', alignItems: 'center', justifyContent: 'space-between',
							flexWrap: 'wrap', gap: 8,
						}}>
							<div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
								<TableOutlined style={{ color: '#1e4d8a', fontSize: 16 }} />
								{!isMobile && <span style={{ fontWeight: 600, color: '#0f2847', fontSize: 15 }}>Hasil BA Batal SKPD</span>}
								<Tag color="blue">{this.groupRows(rows).length} Nopol</Tag>
								<Tag color="cyan">{rows.length} Kejadian</Tag>
								<Tag color="orange">{tgl}</Tag>
							</div>
							<Button
								size={isMobile ? 'middle' : 'large'}
								icon={<PrinterOutlined />}
								style={{ borderRadius: 8, fontWeight: 600, borderColor: '#0f2847', color: '#0f2847', height: 36 }}
								onClick={this.handlePrint}
							>
								{isMobile ? 'Cetak' : 'Cetak PDF'}
							</Button>
						</div>

						{isMobile ? (
							<div style={{ padding: '12px 12px 16px' }}>
								{this.renderMobileResult(rows)}
							</div>
						) : (
							<div style={{ padding: '0 20px 20px', overflowX: 'auto' }}>
								<table className="laporan-table" border="1" cellPadding="5" style={{ width: '100%', marginTop: 16, fontSize: 13 }}>
									<thead>
										<tr>
											<th>No</th>
											<th>Tanggal Batal</th>
											<th>Nopol</th>
											<th>Nama Pemilik Ranmor</th>
											<th>Golongan</th>
											<th>Masa Laku Pajak</th>
											<th>Jumlah SWDKLLJ</th>
											<th>Penyebab</th>
											<th>Loket</th>
										</tr>
									</thead>
									<tbody>
										{rows.length === 0 ? (
											<tr><td colSpan={9} className="teks-tengah" style={{ padding: 20 }}>Tidak ada data pada tanggal ini.</td></tr>
										) : this.groupRows(rows).flatMap((group, gi) => {
											const span = group.length;
											return group.map((r, i) => (
												<tr key={`${gi}-${i}`}>
													{i === 0 && <td rowSpan={span} className="teks-tengah">{gi + 1}</td>}
													{i === 0 && <td rowSpan={span} className="teks-tengah">{r.tanggal_batal}</td>}
													{i === 0 && <td rowSpan={span} className="teks-tengah">{r.nomor_polisi}</td>}
													{i === 0 && <td rowSpan={span}>{r.nama_pemilik}</td>}
													{i === 0 && <td rowSpan={span} className="teks-tengah">{r.golongan}</td>}
													{i === 0 && <td rowSpan={span} className="teks-tengah">{r.masa_laku_skpd}</td>}
													<td className="teks-kanan">{this.fmtRp(r.jumlah_swdkllj)}</td>
													<td>{r.penyebab}</td>
													<td className="teks-tengah">{r.loket}</td>
												</tr>
											));
										})}
									</tbody>
								</table>
							</div>
						)}
					</Card>
				)}

				{/* ── EMBEDDED PRINT SECTION ── */}
				{hasData && (
					<div className="ba-batal-print-section" style={{ display: 'none' }}>
						<div className="kertas-laporan">

							{/* Header */}
							<div style={{ textAlign: 'center', marginBottom: 10 }}>
								<div style={{ fontSize: 14, fontWeight: 'bold' }}>
									BERITA ACARA PEMBATALAN SKPD
								</div>
							</div>

							{/* Paragraf */}
							<div style={{ fontSize: 11, lineHeight: 1.8, marginBottom: 8, textAlign: 'justify' }}>
								{paragraf1}
							</div>
							<div style={{ fontSize: 11, lineHeight: 1.8, marginBottom: 10, textAlign: 'justify' }}>
								{paragraf2}
							</div>

							{/* Tabel */}
							<table className="laporan-table" border="1" cellPadding="3" style={{ width: '100%', fontSize: 9 }}>
								<thead>
									<tr>
										<th style={{ width: 20 }}>No</th>
										<th>Tanggal Batal</th>
										<th>Nopol</th>
										<th>Nama Pemilik Ranmor</th>
										<th>Golongan</th>
										<th>Masa Laku Pajak</th>
										<th>Jumlah SWDKLLJ</th>
										<th>Penyebab</th>
										<th>Loket</th>
									</tr>
								</thead>
								<tbody>
									{this.groupRows(rows).flatMap((group, gi) => {
										const span = group.length;
										return group.map((r, i) => (
											<tr key={`${gi}-${i}`}>
												{i === 0 && <td rowSpan={span} className="teks-tengah">{gi + 1}</td>}
												{i === 0 && <td rowSpan={span} className="teks-tengah">{r.tanggal_batal}</td>}
												{i === 0 && <td rowSpan={span} className="teks-tengah">{r.nomor_polisi}</td>}
												{i === 0 && <td rowSpan={span}>{r.nama_pemilik}</td>}
												{i === 0 && <td rowSpan={span} className="teks-tengah">{r.golongan}</td>}
												{i === 0 && <td rowSpan={span} className="teks-tengah">{r.masa_laku_skpd}</td>}
												<td className="teks-kanan">{this.fmtRp(r.jumlah_swdkllj)}</td>
												<td>{r.penyebab}</td>
												<td className="teks-tengah">{r.loket}</td>
											</tr>
										));
									})}
								</tbody>
							</table>

							{/* Demikian */}
							<div style={{ fontSize: 11, marginTop: 14 }}>
								Demikian Berita Acara ini dibuat, untuk digunakan sebagaimana mestinya.
							</div>

							{/* TTD — 3 kolom */}
							<div style={{ display: 'flex', justifyContent: 'space-around', marginTop: 16, fontSize: 11 }}>
								{/* Kiri: Jasa Raharja */}
								<div style={{ textAlign: 'center', minWidth: 180 }}>
									<div style={{ fontWeight: 'bold' }}>{ttd.kiri?.jabatan || 'PT JASA RAHARJA'}</div>
									<div>Penanggungjawab Samsat</div>
									<div style={{ marginTop: 50 }}>
										<u style={{ fontWeight: 'bold' }}>{ttd.kiri?.nama || '-'}</u>
									</div>
									{ttd.kiri?.nip && ttd.kiri.nip !== '-' && (
										<div>{ttd.kiri.nip}</div>
									)}
								</div>

								{/* Tengah: UPTPPD */}
								<div style={{ textAlign: 'center', minWidth: 180 }}>
									<div style={{ fontWeight: 'bold' }}>{ttd.tengah?.jabatan || `UPTPPD Samsat ${uptNama}`}</div>
									{/* Placeholder kosong - menyamakan tinggi dgn kolom Kiri/Kanan yang
									    punya 2 baris teks (jabatan + sub-label) sebelum nama, supaya nama
									    di 3 kolom sejajar (lihat diskusi 2026-10-07). */}
									<div>&nbsp;</div>
									<div style={{ marginTop: 50 }}>
										<u style={{ fontWeight: 'bold' }}>{ttd.tengah?.nama || '-'}</u>
									</div>
								</div>

								{/* Kanan: Ditlantas */}
								<div style={{ textAlign: 'center', minWidth: 180 }}>
									<div style={{ fontWeight: 'bold' }}>{ttd.kanan?.jabatan || 'Ditlantas Polda'}</div>
									<div style={{ fontWeight: 'bold' }}>KASI STNK</div>
									<div style={{ marginTop: 50 }}>
										<u style={{ fontWeight: 'bold' }}>{ttd.kanan?.nama || '-'}</u>
									</div>
									{ttd.kanan?.nip && ttd.kanan.nip !== '-' && (
										<div>{ttd.kanan.nip}</div>
									)}
								</div>
							</div>

						</div>
					</div>
				)}
			</div>
		);
	}
}

const mapStateToProps = (state) => state.configReducers;

export default connect(mapStateToProps, {
	initHandler, setConfig, ajaxViewHandler, ajaxHandler,
})(LapBaBatalSkpd);
